import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: center;

  strong {
    font-weight: 500;
  }

  ${mediaQueries.tablet} {
    display: inline-block;
  }
`
